import React, { useState } from "react";

const CustomPagination = ({ pagination, onPageChange }) => {
  const { page, totalPages, hasPrevPage, hasNextPage } = pagination;

  return (
    <ul id="pageNumberContent" className="pages flex gap-2">
      <li id="prev">
        <a
          href="#"
          onClick={(e) => {
            if (hasPrevPage) {
              e.preventDefault();
              onPageChange(page - 1);
            }
          }}
          className={`px-3 py-1 rounded ${
            hasPrevPage
              ? "bg-blue-500 text-white"
              : "bg-gray-300 cursor-not-allowed"
          }`}
          style={{ pointerEvents: hasPrevPage ? "auto" : "none" }}
        >
          Prev
        </a>
      </li>

      {[...Array(totalPages)].map((_, i) => {
        const pageNum = i + 1;
        return (
          <li key={pageNum} id="pageNumber">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                onPageChange(pageNum);
              }}
              //   className={`px-3 py-1 rounded ${
              //     page === pageNum ? "bg-blue-600 text-white" : "bg-gray-200"
              //   }`}
              className={page == pageNum ? "select" : ""}
            >
              {pageNum}
            </a>
          </li>
        );
      })}

      <li id="next">
        <a
          href="#"
          onClick={(e) => {
            if (hasNextPage) {
                e.preventDefault();
              onPageChange(page + 1);
            }
          }}
          className={`px-3 py-1 rounded ${
            hasNextPage
              ? "bg-blue-500 text-white"
              : "bg-gray-300 cursor-not-allowed"
          }`}
          style={{ pointerEvents: hasNextPage ? "auto" : "none" }}
        >
          Next
        </a>
      </li>
    </ul>
  );
};

export default CustomPagination;
